import _extends from "@babel/runtime/helpers/extends";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import React from 'react';
import { Form as AntForm } from 'antd';
import styled from 'styled-components'; // @ts-ignore

import { generateShouldUpdateProps } from '@kargotech/tms-common/Utilities/form';
var FormItem = styled(AntForm.Item).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['secondaryLabel', 'labelFontWeight'].includes(prop);
  }
}).attrs({
  labelCol: {
    span: 24
  },
  wrapperCol: {
    span: 24
  }
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    &.ant-form-item {\n      margin-bottom: 0;\n\n      & .ant-form-item-label {\n        padding: 0;\n\n        & > label {\n          font-size: 0.9rem;\n          font-weight: ", ";\n          &.ant-form-item-required:before {\n            display: none;\n          }\n          &:after {\n            content: ", ";\n            display: ", ";\n            margin-left: 1rem;\n            color: ", ";\n            font-size: 0.9rem;\n          }\n        }\n      }\n\n      & .ant-input, & .ant-input-affix-wrapper {\n        &:focus, &-focused {\n          box-shadow: none;\n        }\n      }\n\n      & .ant-form-item-explain {\n        font-size: 0.9rem;\n        padding-top: 0.25rem;\n      }\n\n      & .ant-form-item-extra {\n        font-size: ", ";\n      }\n    }\n  "])), function (props) {
  return props.labelFontWeight ? props.labelFontWeight : 'normal';
}, function (props) {
  return props.secondaryLabel ? "'".concat(props.secondaryLabel, "'") : '';
}, function (props) {
  return props.secondaryLabel ? 'inline-block' : 'none';
}, function (props) {
  return props.theme.colors.darkGrey;
}, function (props) {
  return props.theme.fontSizes.small;
});

function FormUpdateItem(_ref) {
  var _ref$dependencies = _ref.dependencies,
      dependencies = _ref$dependencies === void 0 ? [] : _ref$dependencies,
      _ref$useShouldUpdate = _ref.useShouldUpdate,
      useShouldUpdate = _ref$useShouldUpdate === void 0 ? true : _ref$useShouldUpdate,
      _ref$children = _ref.children,
      children = _ref$children === void 0 ? '' : _ref$children;
  var shouldUpdate = useShouldUpdate ? function (prev, curr) {
    return generateShouldUpdateProps(dependencies)(prev, curr);
  } : undefined;
  return /*#__PURE__*/React.createElement(FormItem, {
    dependencies: useShouldUpdate ? undefined : dependencies,
    noStyle: true,
    shouldUpdate: shouldUpdate
  }, function (params) {
    return typeof children === 'function' ? children(params) : children;
  });
}

var Form = AntForm;
Form.Item = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(FormItem, _extends({
    ref: ref
  }, props));
});
Form.UpdateItem = FormUpdateItem;
export default Form;